import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { ConnectedRouter } from 'react-router-redux';
import Routes from './Routes';
import { apolloClient } from '../apollo';
import { reduxStore, history } from '../redux';
import '../styles/normalize.css';
import '../styles/webflow.css';
import '../styles/offerboard-webflow.css';
import '../styles/custom.css';

const App = () => (
  <ApolloProvider client={apolloClient} store={reduxStore}>
    <ConnectedRouter history={history}>
      <Routes />
    </ConnectedRouter>
  </ApolloProvider>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js